import { ColumnIds } from 'enums';

export const TABLE_PRESETS: {
  [key: string]: Array<TablePreset>;
} = {
  fixtures: [
    {
      id: 1,
      name: 'Default columns',
      columns: [ColumnIds.Id, ColumnIds.Name, ColumnIds.SportId, ColumnIds.StartDate],
      editable: false,
    },
    {
      id: 2,
      name: 'Default filters',
      filters: [
        {
          columnId: ColumnIds.Id,
          condition: 'in',
          value: 90931974,
        },
        {
          columnId: ColumnIds.Name,
          condition: 'contains',
          value: 'Test',
        },
      ],
      editable: false,
    },
    {
      id: 3,
      name: 'Default orders',
      sorts: [
        {
          columnId: ColumnIds.SportId,
          order: 'asc',
        },
        {
          columnId: ColumnIds.SportName,
          order: 'desc',
        },
        {
          columnId: ColumnIds.Id,
          order: 'asc',
        },
        {
          columnId: ColumnIds.Name,
          order: 'desc',
        },
        {
          columnId: ColumnIds.StartDate,
          order: 'asc',
        },
      ],
      editable: false,
    },
  ],
};
